module.exports = __webpack_public_path__ + "media/images/sales/nanairoweek/eyecatch-finished-23e42b5d14ed3e78790be7a9d8ab3663.png";